module.exports = __webpack_public_path__ + "img/Porto Apartment - 60 of 85.b3730a72.jpeg";